import { EntryType } from 'api/graphql/generated/graphql';
import { useCallback } from 'react';

import { Checkbox, CheckboxGroup } from '@limepayments/cosmic';

import { SmallCheckboxes } from './FilterDropdown';

export type EntryTypeFilterProps = {
  value: EntryType[];
  onChange: (value: EntryType[]) => void;
};

export function EntryTypeFilter({ value, onChange }: EntryTypeFilterProps) {
  const onToggle = useCallback(
    (status: EntryType) => {
      onChange(
        value.some((value) => value === status) ? [...value].filter((value) => value !== status) : [...value, status],
      );
    },
    [onChange, value],
  );

  const TypeCheckbox = useCallback(
    ({ type }: { type: EntryType }) => (
      <Checkbox
        variant="body-3"
        id={type}
        label={type}
        checked={value.some((value) => value === type)}
        onChange={() => onToggle(type)}
        testId={`payout-filter-type-check-${type}`}
      />
    ),
    [onToggle, value],
  );

  return (
    <SmallCheckboxes>
      <CheckboxGroup>
        {Object.values(EntryType).map((type) => (
          <TypeCheckbox key={type} type={type} />
        ))}
      </CheckboxGroup>
    </SmallCheckboxes>
  );
}
